import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ThankYou from './views/ThankYou.vue';
import store from './store/index';

Vue.use(Router);

const meta = {
  title: `${store.getters.title}`,
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta,
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: ThankYou,
      meta,
    },
  ],
});
